import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const AdminOrderSmsContainer = styled(Box)({
	width: "100%",
});
